export const BASE_AUTH_TOKEN = 'access_token';
export const BASE_I18NEXT_KEY = 'i18nextLng';
export const BASE_SIDEBAR_COLLAPSED = 'sidebarCollapsed';
